import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/LoanEnquiry.css";

const LoanEnquiry = () => {
    const form = useRef();
    const [showPopup, setShowPopup] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_gozfspq",     // replace
                "template_u7j6x0x",    // replace
                form.current,
                "-McrsyVaJWO1_MO7k"      // replace
            )
            .then(
                () => {
                    setShowPopup(true);
                    form.current.reset();
                },
                (error) => {
                    alert("Failed to send enquiry. Please try again.");
                    console.log(error.text);
                }
            );
    };

    return (
        <div className="enquiry-page">
            {/* HERO */}
            <section className="enquiry-hero">
                <div className="hero-content">
                    <h1>Loan Enquiry</h1>
                    <p>
                        Let Sahyadri Sahakari Bank Ltd help you achieve your financial goals.
                        Submit your enquiry and our team will contact you shortly.
                    </p>
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="enquiry-section container">
                <div className="enquiry-left">
                    <h2>Why Apply With Us?</h2>
                    <p>
                        We provide transparent loan processing, competitive interest rates,
                        and quick approvals. Our dedicated support team ensures that your
                        loan journey is smooth and stress-free.
                    </p>
                    <p><b>Send us a Enquiry and Our team will get back to You</b></p>

                    <img
                        src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c"
                        alt="Banking"
                    />
                </div>

                <div className="enquiry-right">
                    <form ref={form} onSubmit={sendEmail} className="enquiry-form">
                        <h2>Send Your Enquiry</h2>

                        <input type="text" name="name" placeholder="Full Name" required />

                        <input
                            type="tel"
                            name="mobile"
                            placeholder="Mobile Number"
                            required
                        />

                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            required
                        />

                        <select name="loan_type" required>
                            <option value="">Select Loan Type</option>
                            <option>Vehicle Loan</option>
                            <option>Home Loan</option>
                            <option>Mortgage Loan</option>
                            <option>Education Loan</option>
                            <option>Gold Loan</option>
                            <option>Suvasini Scheme</option>
                            <option>Vyapari Scheme</option>
                            <option>Sukhakarta Thev Yojana</option>
                            <option>Sahyadri Navudyojak Scheme</option>
                            <option>Mahalaxmi Thev Yojana</option>

                        </select>

                        <input
                            type="text"
                            name="location"
                            placeholder="Your Location"
                            required
                        />

                        <textarea
                            name="message"
                            placeholder="Write your message..."
                            rows="4"
                            required
                        ></textarea>

                        <button type="submit">Send Enquiry</button>
                    </form>
                </div>
            </section>

            {/* SUCCESS POPUP */}
            {showPopup && (
                <div className="popup">
                    <div className="popup-content">
                        <h3>Enquiry Submitted Successfully!</h3>
                        <p>
                            Thank you for contacting Sahyadri Sahakari Bank Ltd.
                            Our team will get back to you soon.
                        </p>
                        <button onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoanEnquiry;